import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core'
import {faPhone} from '@fortawesome/pro-solid-svg-icons/faPhone'
import {TranslocoService} from '@ngneat/transloco'
import {Language} from '../../../../core/i18n/language'
import {DynamicCategoryLandingPage} from '../../../../core/content/types/category-landing-page.types'

@Component({
  selector: 'bgo-category-landing-page-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerComponent {
  @Input() content!: Pick<
    DynamicCategoryLandingPage,
    | 'title'
    | 'description'
    | 'primaryCallToAction'
    | 'secondaryCallToAction'
    | 'showPartnershipSection'
    | 'partnershipImage'
    | 'bannerImage'
  >

  @Output() callToActionClicked = new EventEmitter<void>()

  readonly phoneIcon = faPhone
  readonly Language = Language

  constructor(readonly translocoService: TranslocoService) {}

  get hasCustomPartnershipLogo(): boolean {
    return this.content.showPartnershipSection && !!this.content.partnershipImage
  }
}
